import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './services/api.service';
import { captureSimrPostRoleRedirect } from './utils/simr-role-selection';

export const authGuard: CanActivateFn = async (route, state) => {
  const url = new URL(window.location.href);
  const accessUserId = url.searchParams.get('access_user_id');
  const router = inject(Router);
  const api = inject(ApiService);
  const storedUserId =
    accessUserId ||
    sessionStorage.getItem('access_user_id') ||
    localStorage.getItem('access_user_id');
  if (accessUserId && !localStorage.getItem('access_token')) {
    try {
      await api.ensureAccessUserLogin(accessUserId);
    } catch {
      captureSimrPostRoleRedirect(state.url);
      router.navigate(['login']);
      return false;
    }
  } else if (storedUserId && api.accessTokenExpired()) {
    try {
      await api.ensureAccessUserLogin(storedUserId);
    } catch {
      // Keep the current page. A failed renewal follows the existing login check.
    }
  } else if (api.accessTokenExpired()) {
    try {
      await firstValueFrom(api.refresh_token());
    } catch {
      // A still-valid token is unchanged. A failed refresh follows the existing login check.
    }
  }
  const isLoggedIn = !!localStorage.getItem('access_token') || !!accessUserId;
  if (!isLoggedIn) {
    captureSimrPostRoleRedirect(state.url);
    router.navigate(['login']);
    return false;
  }
  return true;
};